export const ToLocaleDateString = (value: any) => {
    const date = new Date(`${value}`);
    return date ? date.toLocaleDateString() : null;
}